import { Injectable } from '@angular/core';
import { GoogleMapService } from '@core/services/google_map_service/google-map.service';
import { LocationErrorMessage } from '@shared/enums/location-error-message.enum';

export enum LocationError {
    PERMISSION_DENIED = 1,
    FETCH_FAILURE = 2,
    TIMEOUT = 3,
    NETWORK_ERROR = 4
}

@Injectable({
  providedIn: 'root'
})

export class WebApiLocationService {

    constructor(
        private gService: GoogleMapService,
    ) { }

    async getCurrentLocation() {
        const isMapLoadedSuccessfully = await this.gService.loadGoogleMap().catch(() => {return false;});
        return this.fetchUsingWebApi(isMapLoadedSuccessfully);
    }

    private fetchUsingWebApi(isMapLoadedSuccessfully: boolean) {
        return new Promise((resolve, reject) => {
            if (isMapLoadedSuccessfully) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        });
                    }, (errorResp) => {
                        reject({
                            error: true,
                            code: errorResp.code,
                            message: (errorResp.code === 1) ? LocationErrorMessage.FIRST : LocationErrorMessage.SECOND
                        });
                    }, { timeout: 10000 });
            } else {
                reject({
                    error: true,
                    message: "Error loading in google map"
                });
            }
        });
    }

}
